export const TreatmentRow = {
  flow: 'x',
  gap: 'Z',
  align: 'center flex-start',
  padding: 'Z A',
  borderBottom: '1px solid inkBorder',
  ':last-child': { borderBottom: 'none' },

  ToothBadge: {
    text: (el, s) => '#' + (s.tooth || ''),
    fontSize: (el, s) => s.root.chairSideMode ? 'Z' : 'Y',
    fontWeight: '700',
    color: 'teal',
    background: 'teal.10',
    width: (el, s) => s.root.chairSideMode ? 'C' : 'B',
    height: (el, s) => s.root.chairSideMode ? 'C' : 'B',
    round: 'E',
    textAlign: 'center',
    lineHeight: (el, s) => s.root.chairSideMode ? 'C' : 'B',
    flow: 'x',
    align: 'center center'
  },

  ProcedureName: {
    text: (el, s) => s.procedure || '',
    fontSize: (el, s) => s.root.chairSideMode ? 'A' : 'Z',
    color: 'inkText',
    fontWeight: (el, s) => s.root.chairSideMode ? '700' : '500',
    flex: '1',
    minWidth: 'D'
  },

  CDTCode: {
    text: (el, s) => s.code || '',
    fontSize: 'Y',
    color: 'inkMuted',
    fontFamily: 'monospace',
    fontWeight: '500',
    width: 'D'
  },

  ProviderName: {
    text: (el, s) => s.provider || '',
    fontSize: 'Y',
    color: 'inkMuted',
    width: 'E'
  },

  FeeAmount: {
    show: (el, s) => !s.root.chairSideMode,
    text: (el, s) => s.fee || '',
    fontSize: 'Z',
    color: 'teal',
    fontWeight: '600',
    width: 'C',
    textAlign: 'right'
  },

  InsuranceEstimate: {
    show: (el, s) => !s.root.chairSideMode,
    text: (el, s) => s.insurance || '',
    fontSize: 'Y',
    color: 'inkSubtle',
    width: 'C',
    textAlign: 'right'
  },

  PatientPortion: {
    show: (el, s) => !s.root.chairSideMode,
    text: (el, s) => s.patientPortion || '',
    fontSize: 'Z',
    color: 'inkText',
    fontWeight: '700',
    width: 'C',
    textAlign: 'right'
  },

  RowStatus: {
    extends: 'StatusBadge'
  }
}
